import * as React from "react";
import { Alert, Button } from "react-bootstrap";

import { DocsHeading } from "components/docs/DocsHeading";
import { FlowDiagram } from "components/docs/FlowDiagram";
import { Schematic } from "components/docs/Schematic";
import { SourceCode } from "components/docs/SourceCode";
import { Mock } from "components/docs/Mock";

// FIXME: does not appear to be working?
const Wrapper = ({ children, ...props }) => {
  console.log("Rendering wrapper with children", children, "props", props);
  console.log(children.map((child) => child.props.mdxType));
  return <>{children}</>;
};

export const mdxComponentMap = {
  wrapper: Wrapper,
  DocsHeading,
  FlowDiagram,
  Schematic,
  SourceCode,
  Mock,
  Alert,
  button: Button,
};
